import { number } from "yup";
import { API_ENDPOINT, STORAGE } from "../constants";
import { HTTP } from "./http";
import { LocalStorageService } from "./LocalStorageService";

export const FollowUpService = {
    getTickets: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-targets-tickets/${account_id}`)
    },
    getAgents: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-agents/${account_id}`)
    },
    getOpenTickets: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-tickets-live/${account_id}`)
    },
    getAgentCard: (account_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-targets-agents/${account_id}`)
    },
    getAgentDetail: (account_id: number, agent_id: number) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-detail-agent/${account_id}/${agent_id}`)
    },
    getTicketsCard:(account_id:number)=>{
        return HTTP.get<any,any>(`${API_ENDPOINT.CORE}stadistics/monitoring/v3/get-targets-tickets/${account_id}`)
    },
    getMessagesLive:(ticket_live:string)=>{
        return HTTP.post<any,any>(`${API_ENDPOINT.CORE}chat/v3.1/get-messages-live`, { ticket_live })
    },
    closeTickets:(ticket:string)=>{
        return HTTP.post<any,any>(`${API_ENDPOINT.CORE}stadistics/closeTicket`, { ticket })
    },
    releaseTickets:(ticket:string)=>{
        return HTTP.post<any,any>(`${API_ENDPOINT.CORE}stadistics/freeTicket`, { ticket })
    },
    redirectTickets:(data: { ticket: string; from_agent_id: number; to_agent_id: number })=>{
        return HTTP.post<any,any>(`${API_ENDPOINT.CORE}chat/redirectTicket`, data)
    },
    
    getInfoClient:(data: { account_client_id: number })=>{
        return HTTP.post<any,any>(`${API_ENDPOINT.CORE}chat/getInfoClient`, data)
    },
    
    getURLSocket:(account_id:number)=>{
        const token = LocalStorageService.get(STORAGE.TOKEN);

        return `${API_ENDPOINT.SOCKET}?token=${token}&accountId=${account_id}`
        // return `${API_ENDPOINT.SOCKET}`
    }
}